var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isService ? _c('div', {
    ref: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('Header'), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    attrs: {
      "userPermission": _vm.userPermission,
      "license": _vm.license,
      "instituteId": _vm.$route.params.instituteId
    }
  })], 1), _vm.isMigrationPopup ? _c('migration-done', {
    attrs: {
      "data": _vm.migration
    },
    on: {
      "hide": function ($event) {
        _vm.migration.isFirstVisit = false;
      }
    }
  }) : _vm._e(), _c('notifications', {
    staticStyle: {
      "margin-bottom": "92px"
    },
    attrs: {
      "group": "search",
      "width": "95%",
      "position": "bottom center"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function (props) {
        return [_c('div', {
          staticClass: "vue-notification",
          class: props.item.type,
          domProps: {
            "innerHTML": _vm._s(_vm.tt(props.item.text))
          }
        })];
      }
    }], null, false, 1133203441)
  }), _c('notifications', {
    staticStyle: {
      "margin-bottom": "104px"
    },
    attrs: {
      "width": "95%",
      "position": "bottom center"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function (props) {
        return [_c('div', {
          staticClass: "vue-notification",
          class: props.item.type,
          domProps: {
            "innerHTML": _vm._s(_vm.tt(props.item.text))
          }
        })];
      }
    }], null, false, 1133203441)
  }), _c('portal-target', {
    attrs: {
      "name": "lm-modal",
      "multiple": ""
    }
  })], 1) : _c('div', [_vm.migration.status === 'ING' ? _c('ingPage', {
    attrs: {
      "data": _vm.migration
    }
  }) : _c('available-page')], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }